
// Maximum lengths for phone numbers by country (excluding leading zeros and country code)
export const PHONE_NUMBER_MAX_LENGTHS: Record<string, number> = {
  "+254": 9, // Kenya
  "+256": 9, // Uganda
  "+255": 9, // Tanzania
  "+251": 9, // Ethiopia
  "+250": 9, // Rwanda
  "+1": 10,   // US/Canada
  "+44": 10,  // UK
  "+91": 10,  // India
  "+234": 10, // Nigeria
  "+27": 9,   // South Africa
  "+971": 9,  // UAE
  "+61": 9,   // Australia
  "+49": 11,  // Germany
  "+33": 9,   // France
  "+86": 11,  // China
  "+55": 11,  // Brazil
  "+52": 10,  // Mexico
  "+81": 10,  // Japan
};

// Default max length if country code is not found
export const DEFAULT_PHONE_MAX_LENGTH = 10;

export const getPhoneMaxLength = (countryCode: string): number => {
  return PHONE_NUMBER_MAX_LENGTHS[countryCode] || DEFAULT_PHONE_MAX_LENGTH;
};
